var newValidateRegExp = require('./newValidateRegExp');
var validate = newValidateRegExp('^[0-9]{10}$');
validate.message = 'Expected 10 digits';

module.exports = validate;
